const data = {
	"body": "<path fill=\"currentColor\" d=\"m237.4 213.3l-56-112A6.2 6.2 0 0 0 176 98a6 6 0 0 0-5.4 3.3l-22.3 44.6A90 90 0 0 1 97 127.2A102.1 102.1 0 0 0 125.8 62H152a6 6 0 0 0 0-12H94V32a6 6 0 0 0-12 0v18H24a6 6 0 0 0 0 12h89.8A90.1 90.1 0 0 1 88 119.2A90.2 90.2 0 0 1 67.1 86a6 6 0 0 0-7.6-3.7a6.1 6.1 0 0 0-3.7 7.7A102.3 102.3 0 0 0 79 127.2A89.4 89.4 0 0 1 24 146a6 6 0 0 0 0 12a101.8 101.8 0 0 0 64-22.6a102.9 102.9 0 0 0 54.5 22.1l-27.9 55.8a6 6 0 0 0 2.7 8.1a6.2 6.2 0 0 0 8.1-2.7l14.3-28.7h72.6l14.3 28.7a6.1 6.1 0 0 0 5.4 3.3a6.6 6.6 0 0 0 2.7-.6a6.2 6.2 0 0 0 2.7-8.1ZM145.7 178l30.3-60.6l30.3 60.6Z\"/>",
	"width": 256,
	"height": 256
};
exports.__esModule = true;
exports.default = data;
